import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PlatformLicenseEntity, PlatformLicensePricingEntity } from 'src/app/store/entity-models';
import { PlatformLicensePricingFormComponent } from '../platform-license-pricing-form/platform-license-pricing-form.component';
import { DeletePlatformLicensePricing, UpsertPlatformLicensePricing } from 'src/app/store/actions/platform-license.actions';
import { Store } from '@ngrx/store';
import { ConfirmationDialogData, DialogConfirmationComponent } from '../../dialogs/dialog-confirmation/dialog-confirmation.component';
import { ModalService } from '@iota/iota-ui-components';

@Component({
    standalone: false,
    selector: 'app-platform-license-pricing',
    templateUrl: './platform-license-pricing.component.html',
    styleUrls: ['./platform-license-pricing.component.scss']
})
export class PlatformLicensePricingComponent implements OnInit {
    @ViewChild('platformLicensePricingForm') platformLicensePricingForm: PlatformLicensePricingFormComponent;

    @Input() platformLicense: PlatformLicenseEntity;
    @Input() platformLicensePricing: PlatformLicensePricingEntity;
    @Input() currentlyActive = false;
    @Input() expandedByDefault = false;
    @Input() editable = false;

    collapsed = true;
    editMode = false;
    formValid = false;

    constructor(
        private store: Store,
        private dialog: ModalService
    ) {}

    ngOnInit(): void {
        this.collapsed = !this.expandedByDefault;
    }

    toggleCollapsed() {
        // The currently active pricing can't be collapsed
        if (this.currentlyActive && !this.collapsed) return;

        // The one that is being edited can't be collapsed
        if (this.editMode && !this.collapsed) return;

        this.collapsed = !this.collapsed;
    }

    enableEditing() {
        this.editMode = true;
    }

    cancelEditing() {
        this.editMode = false;
    }

    deletePricing() {
        const data: ConfirmationDialogData = {
            title: $localize`Delete license pricing?`,
            text: $localize`Are you sure you want to delete the license pricing?`,
            cancelButtonStyle: 'primary',
            confirmButtonStyle: 'error'
        };

        this.dialog
            .open(DialogConfirmationComponent, { data })
            .afterClosed()
            .subscribe((confirmed) => {
                if (confirmed) {
                    this.store.dispatch(
                        DeletePlatformLicensePricing({
                            platformLicenseId: this.platformLicense?.platformLicenseId,
                            platformLicensePricingId: this.platformLicensePricing?.platformLicensePricingId
                        })
                    );
                }
            });
    }

    updateFormValidity(formValid: boolean) {
        this.formValid = formValid;
    }

    async savePricing() {
        const platformLicensePricing = this.platformLicensePricingForm?.getUpsertedPlatformLicensePricing();
        if (!!platformLicensePricing) {
            this.store.dispatch(
                UpsertPlatformLicensePricing({ platformLicenseId: this.platformLicense?.platformLicenseId, platformLicensePricing })
            );
        }
    }
}
